import { useTranslation } from "react-i18next";
import { Tab } from "@headlessui/react";
import { Link } from "react-router-dom";
import { useState } from "react";

import PaymentsHistoryGrid from "./PaymentsHistoryGrid";
export default function PaymentDetailMultiGridTabs({
  paymentHistory,
  policyId,
}) {
  const { t } = useTranslation();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  return (
    <div className="ui-payment-policy-tables px-4 pt-2 pb-4 xl:px-6 xl:pb-6">
      <div className="ui-tabs-sm">
        <Tab.Group selectedIndex={selectedTabIndex}>
          <Tab.List className="rounded-t border border-theme-rule-light bg-ui-gray-light">
            <Tab
              className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                selectedTabIndex === 0 ? "" : "text-ui-blue"
              }`}
              onClick={() => {
                setSelectedTabIndex(0);
              }}
            >
              {t(
                "CustomerPaymentOverView-paymen-details-multi-grid-tab-transaction-history"
              )}
            </Tab>
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel>
              <div className="border border-l-1 border-r-1 pt-2">
                <PaymentsHistoryGrid data={paymentHistory?.slice(0, 5)} />
              </div>
              <div className="px-4 py-3 text-xxs border border-t-0 border-theme-rule-light rounded-b sm:text-xs md:text-sm flex justify-between">
                <Link to={`/payment/billing?tab=history&policyId=${policyId}`}>
                  {t(
                    "CustomerPaymentOverView-paymen-details-multi-grid-tab-view-all"
                  )}
                </Link>
                {paymentHistory
                  ?.slice(0, 5)
                  .find((ph) => ph.type === "Disbursed") && (
                  <p className="text-right">
                    {t(
                      "CustomerPaymentOverView-paymen-details-multi-grid-tab-warning-message1"
                    )}
                  </p>
                )}
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}
